var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.373,
    height: 119.119,
    viewBox: "0 0 183.373 119.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#656d78;}.b{fill:#e8d1b3;}.b,.c,.d,.e,.f,.g,.h,.i,.j,.k{fill-rule:evenodd;}.c{fill:#16232c;}.d{fill:#adadad;}.e{fill:#dedede;}.f{fill:#6d8aa2;}.g{fill:#d81212;}.h{fill:#ffd9c9;}.i{fill:#6f6571;}.j{fill:#d9d9d9;}.k{fill:#cbc7cb;}.l{fill:#ff451b;}.m{fill:#ff947c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-42 -289.693)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M179.683,455.849H3.69c-2.038,0-3.69-.82-3.69-1.831v-2.627c0-1.011,1.652-1.831,3.69-1.831H179.683c2.038,0,3.69.82,3.69,1.831v2.627C183.373,455.03,181.721,455.849,179.683,455.849Z",
    transform: "translate(42 -47.165)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M414.066,228.265H382.021V239.4a5.01,5.01,0,0,0,5,5h11.527l6.876,3.473,8.647-3.473V228.265Z",
    transform: "translate(-339.945 114.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M409.071,162.742H387.018a5.01,5.01,0,0,0-5,5v8.272h32.045v-8.272A5.01,5.01,0,0,0,409.071,162.742Z",
    transform: "translate(-339.945 163.518)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M414.067,206.463H382.022v7.861h32.045Z",
    transform: "translate(-339.945 130.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M242.9,293.7H227.377v7.14a3.121,3.121,0,0,0,3.11,3.113h50.539c0-4.489,0-6.773-3.434-6.773l-6.84-.007c-4.305-.007-7.128-1.11-8.7-3.473H242.9Z",
    transform: "translate(-168.777 64.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M190.638,335.289H146.2c-2.606,4.539-4.7,9.994-2.894,20.427,3.024-10.289,33.737-6.182,36.891,5.692H214.08c1.282-2.9,2.491-5.772,3.55-8.668h-9.554C188.752,345.448,194.965,348.7,190.638,335.289Z",
    transform: "translate(-84.486 33.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M259.559,141.706a72.542,72.542,0,0,1-2.57,9.85l-9.769,3.828-10.893-3.828c.382-20.615,8.085-30.5,14.637-33.7a15.9,15.9,0,0,1,4.78-2.475s3.182,5.091,3.348,5.091A27.344,27.344,0,0,1,260.7,131.28Z",
    transform: "translate(-150.664 199.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M208.392,262.108h20.663c4.759.519,10.612,4.143,10.612,15.369v11.766l-4.689,2.793-6.1-2.793V280.15c0-4.489,0-6.773-3.434-6.773l-6.84-.007c-4.305-.007-7.128-1.11-8.7-3.473C208.687,268.074,208.219,265.5,208.392,262.108Z",
    transform: "translate(-122.73 88.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M332.193,382.724a18.84,18.84,0,0,0-36.891-5.692,19.321,19.321,0,0,0-.828,5.087c-.022.692.454.605,1.1.605Q313.881,382.724,332.193,382.724Z",
    transform: "translate(-236.488 12.196)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M342.43,441.231H313.718a14.364,14.364,0,0,0,28.712,0Z",
    transform: "translate(-251.469 -46.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M41.369,428.81l-24.7,5.685a12.674,12.674,0,1,0,24.7-5.685Z",
    transform: "translate(122.502 -36.953)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M31.426,377.871a17.241,17.241,0,0,0-15.889-7.393C4.363,372.842.727,379.521,0,387.851a17.217,17.217,0,0,0,.382,3.408c.072.317.281.187.626.108l3.866-.886,24.7-5.685,1.85-.425,2.585-.6A17.1,17.1,0,0,0,31.426,377.871Z",
    transform: "translate(134.295 7.062)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M97.589,258.958,87.61,224.43l-4.493-2.01-5.025,2.01c6.6,18.3,4.759,31.077.3,43.268-1.066,2.9-2.275,5.764-3.549,8.668h7.178Z",
    transform: "translate(52.264 118.553)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M213.378,65.927l-11.707-2.493c-1.188.108-4.586,2.961-4.586,4.748l2.491,12.667a11.433,11.433,0,0,0,3.276.483,11.319,11.319,0,0,0,10.526-15.405Z",
    transform: "translate(-94.426 238.342)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M213.359,29a14.259,14.259,0,1,0-28.51,0c0,5.317,2.16,10.044,6.077,12.789a13.6,13.6,0,0,0,4.852,2.133V31.255c0-1.787.907-2.147,2.1-2.255h15.486Z",
    transform: "translate(-90.627 275.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M192.093,372.171H181.308v6.795c0,1.456.792,1.564,1.958,1.564h15.479C199.055,373.713,194.93,372.171,192.093,372.171Z",
    transform: "translate(-75.156 5.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M109.574,185.023,96.1,189.476c-.662.591.086,6.615.533,6.42H112.3v-9.915c0-1.953-1.015-1.52-2.722-.958Z",
    transform: "translate(32.381 147.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M150.012,209.412h6.811c3.658,0,3.765-6.067-.533-6.42l-6.278-.5-1.685,3.567Z",
    transform: "translate(-27.803 133.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M197.735,169.4l-2.253-1.938c-5.644-4.864-12.779,3.343-5.234,8.243l6.35,4.121,3.2,2.075H209.91v-6.924l-6.285-.512Z",
    transform: "translate(-87.701 161.083)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M238.536,219.771Z",
    transform: "translate(-129.641 121.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M216.236,1.843a2.278,2.278,0,0,0-4.451,0l-1.547,5.653L214,11.217l3.759-3.724Zm0,0",
    transform: "translate(-16.33 344.925)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M135.783,246.951l-6.678-24.828-9.889-3.724-9.889,3.724-6.8,24.828Zm0,0",
    transform: "translate(78.396 152.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M172.624,61.813h-7.518l-6.184,22.594H178.7Zm0,0",
    transform: "translate(28.803 290.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M81.993,434.738h-30.8c-2.656,0-4.83,1.676-4.83,3.724V439.7H86.823v-1.241C86.823,436.414,84.649,434.738,81.993,434.738Zm0,0",
    transform: "translate(130.896 -37.286)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus12);
export default __webpack_public_path__ + "static/media/status-12.655404d3e4f0ea69a485c3a69395da19.svg";
export { ForwardRef as ReactComponent };